import React from 'react';

/**
 * The hand-drawn glyphs the Portal surfaces share: stroke 2, square caps, miter joins,
 * Lucide-style. Inline SVG, no icon library (handoff §5.1).
 */
const g = (w = 2) => ({ fill: 'none', stroke: 'currentColor', strokeWidth: w, strokeLinecap: 'square', strokeLinejoin: 'miter' });

export const TicketIcon = ({ size = 14, w = 2.25 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(w)} aria-hidden>
    <path d="M3 6h18v4a2 2 0 000 4v4H3v-4a2 2 0 000-4z" />
    <path d="M14 6v2M14 11v2M14 16v2" />
  </svg>
);
export const PinIcon = ({ size = 13, w = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(w)} aria-hidden>
    <path d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);
export const PinOnlyIcon = ({ size = 11, w = 2.25 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(w)} aria-hidden>
    <path d="M12 22s7-6.5 7-12a7 7 0 10-14 0c0 5.5 7 12 7 12z" />
  </svg>
);
export const ClockIcon = ({ size = 19 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);
export const ScissorsIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M8.5 8.5L20 20M8.5 15.5L20 4" />
  </svg>
);
export const ResetIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <path d="M4 4v6h6" />
    <path d="M20 12a8 8 0 10-2.3 5.7M4.6 10A8 8 0 0112 4" />
  </svg>
);
export const RotateIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.5)} aria-hidden>
    <path d="M20 4v6h-6" />
    <path d="M20 10a8 8 0 10-2 7" />
  </svg>
);
export const HighlightIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <rect x="3" y="3" width="18" height="18" />
    <path d="M8 17l4-10 4 10M9.5 13.5h5" />
  </svg>
);
export const SearchIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.25)} aria-hidden>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-4-4" />
  </svg>
);
export const TrashIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.25)} aria-hidden>
    <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />
  </svg>
);
export const XIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.25)} aria-hidden>
    <path d="M5 5l14 14M19 5L5 19" />
  </svg>
);
export const ChevronLeftIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <path d="M15 5l-7 7 7 7" />
  </svg>
);
export const ChevronRightIcon = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.25)} aria-hidden>
    <path d="M9 5l7 7-7 7" />
  </svg>
);
export const CalendarIcon = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.25)} aria-hidden>
    <rect x="3" y="5" width="18" height="16" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);
export const ArrowDownIcon = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g(2.5)} aria-hidden>
    <path d="M12 4v16M5 13l7 7 7-7" />
  </svg>
);
export const LockIcon = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <rect x="4" y="11" width="16" height="10" />
    <path d="M8 11V7a4 4 0 018 0v4" />
  </svg>
);
export const EyeIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" {...g()} aria-hidden>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
